module.exports = __webpack_public_path__ + "static/media/person-richard-davison.ca43258c.png";